import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Divider,
  Stack,
  Typography,
  Zoom,
} from "@mui/material";
import { DataGrid } from '@mui/x-data-grid';
import { green, grey } from "@mui/material/colors";

function App() {

  const rows = [
    { id: 1, price: 2500, status: 'pending' },
    { id: 1, price: 25000, status: 'Out of date' },
    { id: 1, price: 1200, status: 'paid' },
    
  ];
  
  const columns = [
    { field: 'id', headerName: 'ID', width: 150 },
    { field: 'price', headerName: 'Price', width: 150 },
    { field: 'status', headerName: 'Status', width: 150 },
  ];
  return (
    <Zoom in={true} style={{ transitionDelay: "200ms" }}>
      <Stack display={"flex"} rowGap={2}>
        <Box display={"flex"} justifyContent={"center"} columnGap={1}>
          <Card sx={{ width: "60%" }}>
            <CardContent sx={{ bgcolor: grey[900] }}>
              <Typography variant="h6" color={grey[50]}>
                Welcome to Kalsoft
              </Typography>
              <Typography variant="body1" color={grey[50]} mt={2}>
                A one stop system to manage all your business aspects
              </Typography>
              <Typography variant="body1" color={grey[50]} mt={2}>
                Would you like to check on your profile?
              </Typography>
              <Box display={"flex"} justifyContent={"center"}>
                <Button
                  variant="contained"
                  color="success"
                  sx={{ borderRadius: 4, mt: 2 }}
                >
                  Check now
                </Button>
              </Box>
            </CardContent>
          </Card>
          <Card sx={{ width: "38%" }}>
            <CardContent sx={{ bgcolor: grey[700] }}>
              <Typography variant="h6" color={grey[50]}>
                Top Apps
              </Typography>
            </CardContent>
          </Card>
        </Box>
        <Box display={"flex"} justifyContent={"center"} columnGap={1}>
          <Card sx={{ width: "32%" }}>
            <CardContent sx={{ bgcolor: grey[700] }}>
              <Typography variant="body1" color={grey[50]} mt={2}>
                Top Notification
              </Typography>
            </CardContent>
          </Card>
          <Card sx={{ width: "32%" }}>
            <CardContent sx={{ bgcolor: grey[700] }}>
              <Typography variant="body1" color={grey[50]} mt={2}>
                My Todo
              </Typography>
            </CardContent>
          </Card>
          <Card sx={{ width: "32%" }}>
            <CardContent sx={{ bgcolor: grey[700] }}>
              <Typography variant="body1" color={grey[50]} mt={2}>
                Total Sales
              </Typography>
            </CardContent>
          </Card>
        </Box>
        <Box display={"flex"} justifyContent={"center"} columnGap={1}>
          <Card sx={{ width: "60%" }}>
            <CardContent sx={{ bgcolor: grey[900] }}>
              <Typography variant="h6" color={grey[50]}>
                New Invoices
              </Typography>
              <Divider variant="middle" sx={{bgcolor:grey[50]}}/>
              <CardContent sx={{ bgcolor: grey[100],borderRadius:4, mt:1 }}>
                <DataGrid 
                
                 rows={rows}
                 columns={columns}
                 sx={{borderRadius:4, mt:1}}
                />
              </CardContent>
            </CardContent>
          </Card>
          <Card sx={{ width: "38%" }}>
            <CardContent sx={{ bgcolor: grey[700] }}>
              <Typography variant="h6" color={grey[50]}>
                Top Apps
              </Typography>
            </CardContent>
          </Card>
        </Box>
      </Stack>
    </Zoom>
  );
}

export default App;
